import React from 'react'
import AdminPanel from './AdminPanel'
import Chatbot from './Cheatbot'

const App = () => {
  return (
    <div>
      {/* <AdminPanel /> */}
      <Chatbot />

    </div>
  )
}

export default App
